export default {
  SHOWING: "Showing ",
  OF: " of ",
  EMPLOYEES: "Employees",
};
